'use strict';

var Bacon, R, addMinMaxHints, menus, noImage, query, resUtil, restaurantId, transformCategory, transformItem, transformMenu, uiHeroes, uiWeight, variables;

Bacon = require('baconjs');

R = require('ramda');

resUtil = require('../utils/resources');

var _require = require('./restaurants-gql');

restaurantId = _require.restaurantId;


query = "query RestaurantMenu($restaurant_id: ID!) {\n  menus(restaurantId: $restaurant_id) {\n    id\n    name\n    description\n    default\n    availability {\n      custom\n      days\n      services\n      time {\n        close\n        open\n      }\n    }\n    categories {\n      id\n      name\n      description\n      priority\n      active\n      image { active original }\n      items {\n        id\n        name\n				active\n        description\n        price\n        minQty\n        multipleSizes\n        modifiersCount\n        featured\n        coupon\n        couponCode\n        priority\n        image {\n          active\n          medium\n          thumb\n        }\n      }\n    }\n  }\n}";

variables = restaurantId.map(R.assoc('restaurant_id', R.__, {})).map(R.bind(JSON.stringify, JSON));

noImage = {
  active: false,
  original: null
};

transformItem = R.evolve({
  id: parseInt
});

transformCategory = R.evolve({
  id: parseInt,
  image: R.defaultTo(noImage),
  items: R.map(transformItem)
});

transformMenu = R.evolve({
  id: parseInt,
  categories: R.map(transformCategory)
});

uiWeight = function uiWeight(item) {
  return R.defaultTo("", item.description).length + (item.featured ? 250 : 0);
};

uiHeroes = R.compose(R.length, R.filter(R.propEq('featured', true)));

addMinMaxHints = function addMinMaxHints(category) {
  var itemUIWeights;
  itemUIWeights = R.map(uiWeight, category.items);
  return R.merge(category, {
    uiMin: R.reduce(R.min, 2e308, itemUIWeights),
    uiMax: R.reduce(R.max, 0, itemUIWeights),
    uiHero: uiHeroes(category.items)
  });
};

menus = Bacon.combineTemplate({
  url: require('./restaurants-gql').url,
  variables: variables,
  operationName: Bacon.constant('RestaurantMenu'),
  query: Bacon.constant(query)
}).skipDuplicates(R.equals).flatMap(resUtil.post).map(R.path(['data', 'menus'])).map(R.filter(R.pipe(R.prop('categories'), R.length, R.lt(0)))).map(R.map(R.evolve({
  categories: R.map(addMinMaxHints)
}))).map(R.map(transformMenu)).map(R.map(R.assoc('priority', 0)));

menus.onValue(function (data) {
  return console.log("MenusGql", data);
});

module.exports = menus;